module.exports = __webpack_public_path__ + "static/media/04_Block.ba829b38.jpg";